import type { TOC } from '@ember/component/template-only';

import BarLoaderComponent from 'webapp/components/bar-loader';

const DesignerBoardLoadingRouteTemplate: TOC<object> = <template>
	<div id="loading">
		<BarLoaderComponent @size="big" />
	</div>
</template>;

export default DesignerBoardLoadingRouteTemplate;
